import React from 'react';
import { useTranslation } from 'react-i18next';
import Card from '../../../../components/Card';
import { PropertyKPI } from '../../../../interfaces/property.interface';

interface StatsProps {
  data: PropertyKPI | null;
}

const Stats: React.FC<StatsProps> = ({ data }) => {
  const { t } = useTranslation();

  return (
    <div className="row g-4 mb-6">
      <Card
        title={t('properties.list.pageTexts.stats.titles.total')}
        value={data?.total_properties ?? 0}
        description={t('properties.list.pageTexts.stats.descriptions.total')}
        icon="ri-home-line ri-26px"
        variant="primary"
        wrapperClassName="col-sm-6 col-xl-4"
      />
      <Card
        title={t('properties.list.pageTexts.stats.titles.active')}
        value={data?.active_properties ?? 0}
        description={t('properties.list.pageTexts.stats.descriptions.active')}
        icon="ri-home-smile-line ri-26px"
        variant="success"
        wrapperClassName="col-sm-6 col-xl-4"
      />
      <Card
        title={t('properties.list.pageTexts.stats.titles.inActive')}
        value={data?.inactive_properties ?? 0}
        description={t('properties.list.pageTexts.stats.descriptions.inActive')}
        icon="ri-home-gear-line ri-26px"
        variant="danger"
        wrapperClassName="col-sm-6 col-xl-4"
      />
    </div>
  );
};

export default Stats;
